import { Tabs } from 'antd';
import { useEffect } from 'react';
import { useRequest } from 'ahooks';
import DeclarationNotice from './components/DeclarationNotice';
import PublicList from './components/PublicList';
import FixMenu from '@/components/FixMenu/FixMenu';
import { getAreaWithName } from '@/services/common';
import './index.less';

export default function Index() {
  const { data: area = [] } = useRequest(getAreaWithName, {
    defaultParams: ['510000'],
  }); // 固定获取四川省内区域

  const data = { area };

  const items = [
    { label: '种粮大户补贴申报通知', key: '2', children: <DeclarationNotice /> },
    { label: '种粮大户补贴公示名单', key: '3', children: <PublicList data={data} /> },
  ];

  useEffect(() => {
  }, []);

  return (
    <div className="bxzn">
      <div className="cyhyhdk-banner">
        种粮大户补贴申报通知
      </div>
      <div className="content-width">
        <Tabs items={items} centered />
      </div>
      <FixMenu />
    </div>
  );
}
